function Services(){
    return (<div class="container">
        <div class="section">
            <h2>Services Available</h2>
            <ul>
                <li>24 X 7 After Sale Support</li>
                <li>Maintenance Services</li>
                <li>Installation and Erection Solutions</li>
                <li>Maintenance Contracts</li>
            </ul>
        </div>
    </div>)
}

export default Services;